import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getUsers } from "../../../_api/Admin";
import { Table } from "../../../_helpers/Table";

export const Collaborateurs = () => {
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        getUsers()
            .then((res) => {
                const active = (res.data || []).filter((u) => u.activated !== false);
                setUsers(active.map((u) => ({
                    row: [`${u.first_name} ${u.last_name}`, u.email, u.category?.name || "-"],
                    data: u,
                })));
            })
            .catch((err) => setError(err?.response?.data?.message || "Erreur de chargement"))
            .finally(() => setLoading(false));
    }, []);

    const rowClick = (data) => navigate(`/talents/collaborateurs/${data.id}`);

    if (loading) {
        return (
            <div className="min-h-full bg-gray-50 flex items-center justify-center py-20">
                <div className="text-center">
                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-app-primary mx-auto mb-4"></div>
                    <p className="text-gray-600 font-medium">Chargement des collaborateurs...</p>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="min-h-full bg-gray-50 flex items-center justify-center">
                <div className="text-center text-red-600">{error}</div>
            </div>
        );
    }

    return (
        <div className="min-h-full bg-gray-50">
            {/* Header */}
            <div className="bg-white border-b border-gray-200 shadow-sm">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
                    <div>
                        <h1 className="text-3xl font-bold text-gray-900">
                            Collaborateurs
                        </h1>
                        <p className="mt-2 text-sm text-gray-600">
                            Gérez les compétences, objectifs et parcours de vos collaborateurs
                        </p>
                    </div>
                </div>
            </div>

            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
                <div className="bg-white rounded-lg shadow-sm border border-gray-200">
                    <div className="p-6 border-b border-gray-200">
                        <div className="flex items-center space-x-3">
                            <div className="flex items-center justify-center w-10 h-10 bg-gradient-to-br from-app-primary to-app-secondary rounded-lg">
                                <svg className="w-6 h-6 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                                </svg>
                            </div>
                            <div>
                                <h2 className="text-xl font-bold text-gray-900">Liste des collaborateurs</h2>
                                <p className="text-sm text-gray-500">{users.length} collaborateur{users.length > 1 ? "s" : ""} actif{users.length > 1 ? "s" : ""}</p>
                            </div>
                        </div>
                    </div>
                    <div className="p-6">
                        {users.length > 0 ? (
                            <Table
                                headers={["Nom", "Email", "Poste"]}
                                rows={users}
                                onClick={rowClick}
                                hideTitle={true}
                            />
                        ) : (
                            <div className="text-center py-12">
                                <svg className="mx-auto h-12 w-12 text-gray-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z" />
                                </svg>
                                <h3 className="mt-4 text-sm font-medium text-gray-900">Aucun collaborateur</h3>
                                <p className="mt-2 text-sm text-gray-500">Aucun collaborateur actif à afficher.</p>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};
